import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/less/normalize.less'
import 'muse-ui/lib/styles/base.less'
import 'muse-ui-loading/dist/muse-ui-loading.css'
import { AutoComplete, Drawer, Grid, List, Button, Switch, Radio, Icon, Helpers, Tabs, Form, TextField, Select, Dialog, Checkbox, Snackbar, Progress, AppBar } from 'muse-ui'
import Toast from 'muse-ui-toast'
import Loading from 'muse-ui-loading'
import 'muse-ui/lib/styles/theme.less'
import './assets/less/hdModel.less'
import './assets/js/rem'
import VueClipboard from 'vue-clipboard2'
import { InitMobileInfo } from '@/utils'

// import VConsole from 'vconsole'

Es6Promise.polyfill()

Vue.use(AutoComplete)
Vue.use(Drawer)
Vue.use(Grid)
Vue.use(List)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(Icon)
Vue.use(Helpers)
Vue.use(Tabs)
Vue.use(Form)
Vue.use(TextField)
Vue.use(Select)
Vue.use(Dialog)
Vue.use(Checkbox)
Vue.use(Snackbar)
Vue.use(Toast, { position: 'top', close: false })
Vue.use(Loading, { size: 16 })
Vue.use(Progress)
Vue.use(VueClipboard)
Vue.use(AppBar)
// Vue.use(new VConsole())
window.mobileInfo = InitMobileInfo()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
